/* eslint-disable max-len, max-params, sort-keys */
import axios from "axios";
export default class StyleSurveyAPI {
  static API_TOKEN = null;

  static API_VERSION = 1;

  static SURVEY_ID = null;

  static setApiToken (apiToken) {
    this.API_TOKEN = apiToken;
  }

  static setSurveyId (survey) {
    this.SURVEY_ID = survey.id;
    delete survey.id;
  }

  static updateSurvey (customerId, survey) {
    return $.ajax({
      "method": "PUT",
      "url": `/api/v${this.API_VERSION}/surveys/${this.SURVEY_ID}`,
      "data": {survey},
      "headers": {"Authorization": `Token token=${this.API_TOKEN}`}
    });
  }

  static updateCustomer (customerId, customer) {
    return $.ajax({
      "method": "PUT",
      "url": `/api/v${this.API_VERSION}/customers/${customerId}`,
      "data": {customer},
      "headers": {"Authorization": `Token token=${this.API_TOKEN}`}
    });
  }

  static validateEmail (email) {
    return axios({
      "method": "post",
      "url": "/validate_email",
      "data": {email},
      "headers": {"Authorization": `Token token=${this.API_TOKEN}`}
    });
  }

  static verifyRecaptchaToken (token) {
    return axios({
      "method": "post",
      "url": "/verify_recaptcha_token",
      "data": {token},
      "headers": {"Authorization": `Token token=${this.API_TOKEN}`}
    });
  }
}
